import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { HttpService } from 'src/app/service/http/http.service';
import { ChangeNeededComponent } from '../change-needed/change-needed.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ProbationfromHODMANAGERComponent } from '../elcm/probationfrom-hod-manager/probationfrom-hod-manager.component';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AddRatingStanderdsComponent } from '../add-rating-standerds/add-rating-standerds.component';
import { ToastrService } from 'ngx-toastr';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { RatingPreviewComponent } from '../rating-preview/rating-preview.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-probation-and-confirmation',
  templateUrl: './probation-and-confirmation.component.html',
  styleUrls: ['./probation-and-confirmation.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ProbationAndConfirmationComponent implements OnInit {

  buttonColorName: any;
  loggedInUserRole: any;
  adminAccessData: any = [];
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  from: any;
  getChangedData: any;
  loggedInUserEmployeeCode: any;
  reportingManager: any;
  confirmationProbationWhomSetup: any;
  userEmail: any;
  dropdownSettings: IDropdownSettings = {};
  @Input() chechsetupStatus: any;
  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,
    private loader: LoaderService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ProbationAndConfirmationComponent>,
    private elcmGenericService: ElcmGenericServiceService,
    public mobileResponsiveService: MobileResponsiveService
  ) {

  }

  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      if (this.loggedInUserRole == 'Admin') {
        this.elcmGenericService.getAllAccessMatrix(this.loggedInUserCompanyID).subscribe({
          next: (data: any) => this.adminAccessData = (data?.status && data?.data?.access[0]) ? data?.data?.access[0] : []
        });
      }
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getChangedData = sessionStorage.getItem('ProbassionChangedData');

    this.reportingManager = this.httpService.reportingManagerForElcm;
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.getpmsyearlist()
  }



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      this.probationTableLableFun();
      this.getProbationDetailsForHODAndManager();
      this.getEmployeeList();
      this.getEmployee();
      this.getProbationEmployeeList();
      this.getCompanyDataByCompID();
      this.chckPRobationEmployee();
      setTimeout(() => {
        this.DislaySelectedRecord(25)
      }, 100)
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }


  emailOfHrAdmin: any;
  checkHRName: any;
  hrID: any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {

      console.log(data?.data);
      this.checkHRName = data?.data.firstnameOfHrAdmin + " " + data?.data.lastnameOfHrAdmin
      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
      this.hrID = data?.data?.companyHrId;


    })
  }
  employeesDetails: any = []
  employeesProbationDetails: any = []
  getEmployeeList() {

    // this.selectedYear
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
      this.employeesDetails = record?.data?.map((record: any) => {
        return {
          ...record,
          probationStatus: null,
          probationExtensionByDay: null,
          reasonForExtension: null,
          changesPostConfirmation: null,
          dateOfConfirmation: null
        }
      });

      if (this.loggedInUserRole == 'Admin') this.employeesDetails = this.elcmGenericService.empFilterForAllEmployeeList(this.employeesDetails, this.adminAccessData?.employeeDetails, 'userId');

      this.getprobationPeriods()

    })
  }
  probationPeriodData: any = []
  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probationPeriodData = record?.data;


        this.getProbationList();
      });
  }


  EmployeeSummaryData: any = [];
  currentemployeesProbationDetails: any = []
  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data?.data;

      this.getEmployeeListOnGoal();
    })
  }
  employeeTeamForHod: any = []
  getEmployeeListOnGoal() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": "January-December",
      "fromYear": this.fromYear,
      "to": "January-December",
      "toYear": this.toYear,
      "userId": this.loggedInUserId,
      "userType": null,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).
      subscribe((data: any) => {
        this.employeeTeamForHod = data?.data;

      })
  }
  lineManagerOrHODData: any = [];
  getProbationDetailsForHODAndManager() {
    this.httpService.callGetService(`${this.config.getDetailsLineManagerOrHOD}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`).subscribe((record: any) => {
      if (record) {

        console.log(record);
        console.log(this.employeesProbationDetails);

        this.lineManagerOrHODData = record?.data;

      }


    })
  }
  probationListData: any = [];
  recommendedBy: any = []
  hodEmployeeList: any = [];
  checkdateOrConfirmationNull: boolean = false;
  getProbationEmployeeList() {
    this.httpService.callGetService(`${this.config.getEmployeeUnderHod}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.loggedInUserEmployeeCode}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`)
      .subscribe((response: any) => {
        this.hodEmployeeList = response;
        console.log(this.hodEmployeeList);
        this.getProbationList()
      }
      )
  }
  checkLineManagerAndHod: any;
  getLocationList: any = []
  useProbationListForFilter: any = []
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;
        this.probationListData = response?.data;
        this.currentemployeesProbationDetails = this.employeesDetails?.map((employee: any) => {


          // Find probation period based on band and grade
          let probationData = this.probationPeriodData?.find((elm: any) =>
            elm.band === employee.band && elm.grade === employee.grade
          );


          // If no matching probation data, set confirmation date as null
          if (!probationData) {
            return {
              ...employee,
              probationDetailId: null,
              probationStatus: null,
              probationExtensionByDay: null,
              checkprobationmonth: null,
              reasonForExtension: null,
              dateOfConfirmation: null, // Set to null if no match
              changesPostConfirmation: null
            };
          }

          let probationPeriod = probationData.probationPeriod; // Months


          // Find employee probation details
          let matchData = this.probationListData.find((elm: any) =>
            elm.empCode === employee.emplCode && elm.grade === employee.grade
          );


          // Convert joining date
          let dateOfJoining = new Date(employee.dateOfJoining); // Convert to Date object
          let finalConfirmationDate = new Date(dateOfJoining); // Create a new Date instance;




          // Add probation period (in months)
          finalConfirmationDate.setMonth(finalConfirmationDate.getMonth() + probationPeriod);

          // If probation is extended, add extra extension days
          if (matchData?.probationStatus === "Extension") {
            finalConfirmationDate.setDate(finalConfirmationDate.getDate() + matchData.probationPeriod);
          }



          return {
            ...employee, // Keep existing employee data
            probationDetailId: matchData ? matchData.probationDetailId : null,
            probationStatus: matchData ? matchData.probationStatus : null,
            probationExtensionByDay: matchData ? matchData.probationExtensionByDay : null,
            checkprobationmonth: matchData ? matchData.probationExtensionByDay : null,
            reasonForExtension: matchData ? matchData.reasonForExtension : null,
            origenaldateOfConfirmation: matchData ? matchData?.dateOfConfirmation : finalConfirmationDate.toISOString().split('T')[0],
            dateOfConfirmation: matchData ? matchData?.dateOfConfirmation : finalConfirmationDate.toISOString().split('T')[0], // Format YYYY-MM-DD
            changesPostConfirmation: matchData ? matchData.changesPostConfirmation : null,
          };
        });


        this.checkdateOrConfirmationNull = this.currentemployeesProbationDetails.some((elm: any) => elm.dateOfConfirmation == null);


        // this.checkLineManagerAndHod = this.currentemployeesProbationDetails.filter((record: any) => record.hodCode == record.reportingManagerCode || record.reportingManagerCode == this.loggedInUserEmpCode)

        this.checkLineManagerAndHod = this.currentemployeesProbationDetails.filter((record: any) => record.hodCode == record.reportingManagerCode)

        if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {
          let data = this.currentemployeesProbationDetails.map((record: any) => {
            console.log(this.lineManagerOrHODData);

            let matchuser = this.lineManagerOrHODData.find((res: any) => res.userId == record.userId);

            console.log(matchuser);
            console.log(record);

            return {
              ...record,
              probationDetailId: matchuser ? matchuser?.probationDetailId : record?.probationDetailId || null,
              matchuser: matchuser ? matchuser?.userId : null,
              recommendedBy: matchuser ? matchuser?.probationCurrentLogUserType : null,
              probationCurrentLogUserType: this.confirmationProbationWhomSetup,
              hodComment: matchuser?.hodComment || null,
              hrComment: matchuser?.hrComment || null,
              recommendationComment: matchuser?.recommendationComment,
              managerComment: matchuser?.managerComment || null,
              employeeComment: matchuser?.employeeComment || null,
              hrName: matchuser?.hrName || null,
              hrEmail: matchuser?.hrEmail || null,

            }
          });
          this.employeesProbationDetails = data;
          this.useProbationListForFilter = data
        } else if (this.loggedInUserRole == 'Manager' && this.confirmationProbationWhomSetup.trim() == 'LINE_MANAGER') {
          const employeeId = this.EmployeeSummaryData.map((record: any) => record.id);
          console.log("Manager.............", employeeId);
          console.log(this.currentemployeesProbationDetails);
          let filterData = this.currentemployeesProbationDetails.filter((elm: any) => elm.reportingManagerCode == this.loggedInUserEmpCode);
          // this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => employeeId.includes(record.userId));
          this.employeesProbationDetails = filterData;
          this.useProbationListForFilter = filterData
        } else if (this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup.trim() == 'LINE_MANAGER') {
          const employeeId = this.EmployeeSummaryData.map((record: any) => record.id);
          console.log("ManagerHOD.............", employeeId);
          console.log(this.currentemployeesProbationDetails);
          let filterData = this.currentemployeesProbationDetails.filter((elm: any) => elm.reportingManagerCode == this.loggedInUserEmpCode);


          // this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => employeeId.includes(record.userId));
          this.employeesProbationDetails = filterData;
          this.useProbationListForFilter = filterData
        }


        else if (this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup == 'HOD') {
          console.log("...................", this.hodEmployeeList);
          console.log("hod");
          const employeeId = this.hodEmployeeList?.data?.data.map((record: any) => record.userId);
          let data = this.currentemployeesProbationDetails.filter((record: any) => record.hodCode == this.loggedInUserEmpCode);
          this.currentemployeesProbationDetails = this.employeesProbationDetails
          this.useProbationListForFilter = data
          this.employeesProbationDetails = data
        } else if (this.checkLineManagerAndHod.length > 0 && this.confirmationProbationWhomSetup == 'LINE_MANAGER') {
          console.log("HODMANAGER_----------------------------", this.currentemployeesProbationDetails);
          // let filterData = this.currentemployeesProbationDetails?.filter((elm: any) => (elm.reportingManagerCode == this.loggedInUserEmpCode && elm.hodCode == this.loggedInUserEmpCode) || elm.reportingManagerCode == this.loggedInUserEmpCode);
          let filterData = this.currentemployeesProbationDetails?.filter((elm: any) => elm.reportingManagerCode == elm.hodCode || elm.reportingManagerCode == this.loggedInUserEmpCode);
          this.employeesProbationDetails = filterData;
          this.currentemployeesProbationDetails = filterData;
          this.useProbationListForFilter = filterData

        }

        this.getLocationList = [];
        this.useProbationListForFilter.forEach((ele: any) => {
          const originalLocation = ele.empCityLocation?.trim(); // Keep original case for display
          const normalizedLocation = originalLocation?.toLowerCase(); // Normalize for comparison

          if (
            originalLocation && // Ensure not undefined
            !this.getLocationList.some(
              (record: any) => record.name?.trim().toLowerCase() === normalizedLocation
            )
          ) {
            this.getLocationList.push({
              id: normalizedLocation, // Keep lowercase for IDs if needed
              empDept: originalLocation, // Store/display original case
              name: originalLocation,
            });
          }
        });

      });
  }
  // isEditable(employee: any): boolean {
  //   if (!employee.dateOfConfirmation) {
  //     return false;
  //   }

  //   const today = new Date(); // Get today's date
  //   const confirmationDate = new Date(employee.dateOfConfirmation); // Convert confirmation date to Date object
  //   const fiveDaysBefore = new Date(confirmationDate);
  //   fiveDaysBefore.setDate(confirmationDate.getDate() - 5); // Calculate 5 days before confirmation

  //   return today >= fiveDaysBefore && today < confirmationDate;
  // }
  employees: any = []
  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      // Reset to the original full list
      this.employeesProbationDetails = [...this.useProbationListForFilter];
      return;
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();

    let data = this.useProbationListForFilter.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );


    this.employeesProbationDetails = data;


  }
  selectedSize: any = 25
  DislaySelectedRecord(event: any) {
    this.selectedSize = event.value || event;
    this.employeesProbationDetails = this.useProbationListForFilter.slice(0, this.selectedSize);
  }

  downloadCSV() {
    const header = ["sr No", "Emp ID", "Emp name", "Dept", "Band", "Grade", "Location", "DOJ", "Date off Confirmation", "Probation", "Extention of probation by", "Reasons for confirmation or probation extension"]
    if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {
      header.push("Change post confirmation");
    }
    const headers = header.map((h: any) => h);
    const rows = this.employeesProbationDetails.map((employee: any, index: any) => [
      index + 1,
      employee.emplCode,
      employee.empName,
      employee.empDept,
      employee.band,
      employee.grade,
      employee.empCityLocation,
      // employee.dateOfJoining,
      // employee.dateOfConfirmation,
      " " + this.datePipe.transform(employee.dateOfJoining, 'dd-MM-yyyy'),   // DOJ formatted (Excel-safe)
      " " + this.datePipe.transform(employee.dateOfConfirmation, 'dd-MM-yyyy'), // Confirmation formatted (Excel-safe)
      employee.probationStatus,
      employee.probationExtensionByDay,
      employee.reasonForExtension,
      (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') ? employee.changesPostConfirmation || '' : '' // Only for HR Admin
    ]);

    let csvContent = "data:text/csv;charset=utf-8,"
      + [headers, ...rows].map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Probation_Details.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  isEditable(employee: any): boolean {
    if (!employee.dateOfConfirmation) {
      return false;
    }

    const today = new Date();
    const confirmationDate = new Date(employee.dateOfConfirmation);
    const fiveDaysBefore = new Date(confirmationDate);
    fiveDaysBefore.setDate(confirmationDate.getDate() - 5);

    // Condition: Editable if within 5-day window or if confirmation date has passed
    return today >= fiveDaysBefore || today > confirmationDate;
  }


  ProbationTableHeader: any = []

  probationTableLableFun() {

    this.ProbationTableHeader = [{ label: "Sr.No" },
    { label: "Emp ID" },
    { label: "Emp name" },
    { label: "Dept" },
    { label: "Band" },
    { label: "Grade" },
    { label: "Location" },
    { label: "DOJ" },
    { label: "Date of Confirmation" },
    { label: "Probation" },
    { label: "Extention of probation by" },
    { label: "Reasons for confirmation or probation extension" },
    { label: 'Action' }
    ]

    // Check if logged-in user is HR admin
    if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {
      const actionIndex = this.ProbationTableHeader.findIndex((item: any) => item.label === "Action");
      if (actionIndex !== -1) {
        this.ProbationTableHeader.splice(actionIndex, 0, { label: "Change post confirmation" });
      }
    }

  }






  onClickOpenChangeNeededPopup(userId: any) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '70%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      userID: userId
    };
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(ChangeNeededComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      // this.getProbationList();
    });
  }
  confirmationFlag: boolean = false;
  confirmationpopp(date: any) {
    console.log(date);
    const currentDate = new Date(); // Get the current date

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    const day = String(currentDate.getDate()).padStart(2, '0'); // Ensure two digits

    const formattedDate = `${year}-${month}-${day}`;
    console.log(date.dateOfConfirmation == formattedDate);

    this.confirmationFlag = date.dateOfConfirmation == formattedDate || date.dateOfConfirmation <= formattedDate
    console.log(this.confirmationFlag);

    if (!this.confirmationFlag && date.probationStatus == null && !this.checkdateOrConfirmationNull) {

      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "You can't Confirm the Employee before Date of confirmation.",
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: true
        }
      });
    }

    return;

  }
  getProbationEmployeeDetails: any;
  getprobationData(employee: any) {
    console.log(employee);
    this.getProbationEmployeeDetails = employee
    console.log(this.probationPeriodData);

  }


  addMonthsToDate(dateString: string, monthsToAdd: number): string {
    const date = new Date(dateString); // Convert string to Date object
    date.setMonth(date.getMonth() + monthsToAdd); // Add months

    // Format the result as YYYY-MM-DD
    return date.toISOString().split("T")[0];
  }

  onProbationChange(event: any) {
    let probationDay = this.probationPeriodData.find(
      (elm: any) => elm.grade === event.grade && elm.band === event.band
    );
    console.log(event);
    let origenalDate = event.origenaldateOfConfirmation;
    console.log(event.probationStatus);

    if (event.probationStatus !== 'Extension' || event.probationStatus.trim() == 'Confirmation') {

      event.probationExtensionByDay = event.checkprobationmonth || null;
      event.dateOfConfirmation = origenalDate
      event.probationExtensionByDay = null;
    }
    else if (event.probationStatus === 'Extension') {

      event.probationExtensionByDay = probationDay ? probationDay.probationExtensionPeriod : null;
      event.dateOfConfirmation = this.addMonthsToDate(event.dateOfConfirmation, probationDay.probationExtensionPeriod);


    }
  }
  checkProbationEmployeeHODmanager: any
  chckPRobationEmployee() {
    this.httpService.callGetService(`${this.config.getEmployeeProbationCheck}/${this.loggedInUserId}/${this.loggedInUserCompanyID}`).subscribe((result: any) => {

      this.checkProbationEmployeeHODmanager = result.data.length > 0
    })
  }
  changedFromEmployee(type: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click
    dialogConfig.data = {

      userId: this.loggedInUserId,
      checkhodbutEmployee: this.checkProbationEmployeeHODmanager,
      hrView: this.loggedInUserRole,
      companyID: this.loggedInUserCompanyID,
      year: this.selectedYear,
      setUp: null,
      checkSelfEmployee: "selfEmployee",
      type: type,
    };
    dialogConfig.panelClass = 'custom-dialog-container';

    // const dialogRef = this.dialog.open(ProbationfromHODMANAGERComponent, dialogConfig);
    const dialogRef = this.dialog.open(AddRatingStanderdsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }

  changedFromHODORManager(userId: any, recommendedBy: any, probationCurrentLogUserType: any, employee: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click

    dialogConfig.data = {
      type: 'view',
      userId: userId,
      recommendedBy: recommendedBy,
      probationCurrentLogUserType: probationCurrentLogUserType,
      hrView: this.loggedInUserRole,
      companyID: this.loggedInUserCompanyID,
      employee: employee,
      year: this.selectedYear,
      setUp: null,
    };
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(AddRatingStanderdsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }
  previewRating(userId: any, recommendedBy: any, probationCurrentLogUserType: any, employee: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%'; // Adjust as needed
    dialogConfig.width = '100%'; // Adjust as needed
    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.disableClose = true; // Prevent closing via ESC or outside click
    dialogConfig.data = {
      userId: userId,
      recommendedBy: recommendedBy,
      probationCurrentLogUserType: probationCurrentLogUserType,
      hrView: this.loggedInUserRole,
      companyID: this.loggedInUserCompanyID,
      year: this.selectedYear,
      employee: employee
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    // const dialogRef = this.dialog.open(ProbationfromHODMANAGERComponent, dialogConfig);
    const dialogRef = this.dialog.open(RatingPreviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }

  SaveProbationData(userId: any, employee: any) {
    // Retrieve stored data from session storage
    const storedData = JSON.parse(sessionStorage.getItem('ProbassionChangedData') || '{}');


    console.log('Stored Data:', employee);
    console.log('Probation Status:', this.getProbationEmployeeDetails);
    console.log('Changes Post Confirmation:', this.getProbationEmployeeDetails?.changesPostConfirmation);

    if (employee?.probationStatus === '' || employee?.probationStatus == null) {
      if (!this.getProbationEmployeeDetails?.changesPostConfirmation) {
        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: "Probation is required",
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          console.log('Error dialog closed');
        });

        return; // Stop execution if validation fails
      }
    }
    // Check if probation status is 'Confirmation' and changes post confirmation is missing
    if (employee?.probationStatus === 'Confirmation') {
      if (!this.getProbationEmployeeDetails?.changesPostConfirmation) {
        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: "Change post confirmation required",
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        errorDialogRef.afterClosed().subscribe(() => {
          console.log('Error dialog closed');
        });

        return; // Stop execution if validation fails
      }
    }

    // Construct changed data object
    let grade = storedData?.grade?.label ? storedData?.grade?.label : storedData?.grade;
    let band = storedData?.band?.label ? storedData?.band?.label : storedData?.band;
    let designation = storedData?.designation?.label ? storedData?.designation?.label : storedData?.designation
    const changedData = {
      annualTotalCtc: storedData?.annualTotalCtc,
      grade: grade,
      band: band,
      designation: designation,
    };
    if (
      this.getProbationEmployeeDetails?.changesPostConfirmation === 'Change_Needed' &&
      changedData.annualTotalCtc == undefined &&
      changedData.grade == undefined &&
      changedData.band == undefined &&
      changedData.designation == undefined
    ) {
      this.toastr.error("Data not field in the change needed pop up");
      return;
    }

    // Construct form data
    const formData = {
      probationDetailId: employee.probationDetailId || null,
      hrId: parseInt(this.hrID),
      userId: userId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear,
      fiscalYear: this.loggedInCompanyFiscalyear,
      empName: this.getProbationEmployeeDetails?.empName,
      empCode: this.getProbationEmployeeDetails?.emplCode,
      empDept: this.getProbationEmployeeDetails?.empDept,
      band: this.getProbationEmployeeDetails?.band,
      grade: this.getProbationEmployeeDetails?.grade,
      doj: this.getProbationEmployeeDetails?.dateOfJoining,
      probationStatus: this.getProbationEmployeeDetails?.probationStatus,
      probationExtensionByDay: this.getProbationEmployeeDetails?.probationExtensionByDay,
      reasonForExtension: this.getProbationEmployeeDetails?.reasonForExtension,
      changesPostConfirmation: this.getProbationEmployeeDetails?.changesPostConfirmation,
      hodCode: this.getProbationEmployeeDetails?.hodCode,
      reportingManagerCode: this.getProbationEmployeeDetails?.reportingManagerCode,
      officialEmail: this.getProbationEmployeeDetails?.officialEmail,
      probationCurrentLogUserType:
        ['HR Admin', 'Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)
          ? null
          : this.confirmationProbationWhomSetup === 'LINE_MANAGER'
            ? 'LINE_MANAGER'
            : this.confirmationProbationWhomSetup === 'HOD'
              ? 'HOD'
              : null,
      "hodComment": employee?.hodComment || null,
      "hrComment": employee?.hrComment || null,
      "recommendationComment": employee?.recommendationComment,
      "managerComment": employee?.managerComment || null,
      "employeeComment": employee?.employeeComment || null,
      "hrName": employee?.hrName || null,
      "hrEmail": employee?.hrEmail || null,
      "whoChangedForm": this.loggedInUserRole
    };

    // Construct salary breakup data
    const salaryBreakUp = {
      userId: userId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear,
      fiscalType: this.loggedInCompanyFiscalyear
    };

    // Construct probation letter data
    const probationLetter = {
      userId: userId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear,
      fiscalType: this.loggedInCompanyFiscalyear,
      employeeCode: this.getProbationEmployeeDetails?.emplCode,
      hrMail: this.emailOfHrAdmin,
      changesPostConfirmation: this.getProbationEmployeeDetails?.changesPostConfirmation === 'Change_Needed'
        ? 'Change_Needed'
        : 'No_Change'
    };

    console.log('Final Data:', this.getProbationEmployeeDetails?.changesPostConfirmation, changedData);
    this.loader.simpleLoaderWithDuration();
    // Call PUT service if there are changes


    if (
      changedData &&
      this.getProbationEmployeeDetails?.changesPostConfirmation !== null &&
      changedData.annualTotalCtc !== undefined &&
      changedData.grade !== undefined &&
      changedData.band !== undefined &&
      changedData.designation !== undefined
    ) {
      this.httpService.callPutService(`${this.config.changedProbation}/${userId}`, changedData).subscribe(
        (response: any) => {
          this.loader.dismissLoader();
          console.log('Changed Data API Success:', response);
        },
        (error: any) => {
          console.error('Changed Data API Error:', error);
        }
      );
    }


    // Call POST service to save probation details
    this.httpService.callPostService(this.config.addUpdateProbationDetails, formData).subscribe(
      (record: any) => {
        if (record) {
          this.loader.dismissLoader();
          this.getEmployeeList();
          console.log('Probation Details API Success:', record);

          // ✅ Show Success Popup

          // Continue only after user closes the popup
          this.httpService.callPostService(this.config.updateProbationLetter, probationLetter).subscribe(
            (letterResponse: any) => {
              if (letterResponse) {
                this.loader.dismissLoader();
                console.log('Probation Letter API Success:', letterResponse);

                const changeNeeded = this.httpService.selectedOptionSalaryBreakUp &&
                  this.getProbationEmployeeDetails?.changesPostConfirmation === 'Change_Needed';

                if (changeNeeded) {
                  this.httpService.callPostService(this.config.updateSalaryBreakupProbation, salaryBreakUp).subscribe(
                    (salaryResponse: any) => {
                      if (salaryResponse) {
                        this.loader.dismissLoader();
                        console.log('Salary Breakup API Success:', salaryResponse);

                        // Send probation letter
                        this.httpService.callPostService(this.config.senbdProbationLetter, probationLetter).subscribe(
                          (letterSentResponse: any) => {
                            if (letterSentResponse) {
                              this.loader.dismissLoader();
                              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                                disableClose: true,
                                height: '25%',
                                width: '30%',
                                data: {
                                  msg: record.message || 'Probation Details Updated Successfully',
                                  btn2: 'OK',
                                  btn2BgColor: this.buttonColorName,
                                  showSuccessIcon: true,
                                  showSuccessMessage: false,
                                  showCloseIcon: false
                                }
                              });

                              dialogRef.afterClosed().subscribe((result) => {
                                console.log(result);

                                this.getProbationEmployeeDetails = null;
                              });
                              this.getEmployeeList();
                            }
                          },
                          (error: any) => {
                            this.loader.dismissLoader();
                            console.error('Error sending probation letter:', error);
                            this.showErrorPopup(error.error?.message || 'Failed to send probation letter');
                          }
                        );
                      }
                    },
                    (error: any) => {
                      this.loader.dismissLoader();
                      console.error('Salary Breakup API Error:', error);
                      this.showErrorPopup(error.error?.message || 'Failed to update salary breakup');
                    }
                  );
                } else {
                  // No salary breakup, send letter directly
                  this.httpService.callPostService(this.config.senbdProbationLetter, probationLetter).subscribe(
                    (letterSentResponse: any) => {
                      if (letterSentResponse) {
                        this.loader.dismissLoader();
                        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                          disableClose: true,
                          height: '25%',
                          width: '30%',
                          data: {
                            msg: record.message || 'Probation Details Updated Successfully',
                            btn2: 'OK',
                            btn2BgColor: this.buttonColorName,
                            showSuccessIcon: true,
                            showSuccessMessage: false,
                            showCloseIcon: false
                          }
                        });

                        dialogRef.afterClosed().subscribe((result) => {
                          console.log(result);

                          this.getProbationEmployeeDetails = null
                        });
                        this.getEmployeeList();
                      }
                    },
                    (error: any) => {
                      this.loader.dismissLoader();
                      console.error('Error sending probation letter:', error);
                      this.showErrorPopup(error.error?.message || 'Failed to send probation letter');
                    }
                  );
                }
              }
            },
            (error: any) => {
              this.loader.dismissLoader();
              console.error('Probation Letter API Error:', error);
              this.showErrorPopup(error.error?.message || 'Failed to update probation letter');
            }
          );

        }
      },
      (error: any) => {
        this.loader.dismissLoader();
        console.error('Probation Details API Error:', error);
        this.showErrorPopup(error.error?.message || 'Failed to save probation details');
      }
    );

  }
  showErrorPopup(message: string) {
    const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: 'red',
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    errorDialogRef.afterClosed().subscribe(() => {
      console.log('Error dialog closed');
    });
  }
  fiterDataForLocation() {

    if (this.selectedLocation.length > 0) {

      // Normalize the deptID array by trimming and converting to lowercase
      const location = this.selectedLocation.map((elm: any) => elm?.name?.trim().toLowerCase());
      // Filter employees based on the normalized deptID values
      this.employeesProbationDetails = this.useProbationListForFilter.filter((record: any) =>
        location.includes(record?.empCityLocation?.trim().toLowerCase()) // Normalize empDept as well
      );
    }

    else {
      this.clearSelections();

      this.employeesProbationDetails = this.useProbationListForFilter;
    }


  }

  clearSelections() {
    this.selectedLocation = [];
  }
  selectedLocation: any = [];
  onselectLocation() {
    if (this.selectedLocation && this.selectedLocation.length > 0) {
      this.fiterDataForLocation();
    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  onDeSelectLocation() {

    this.fiterDataForLocation();
  }

  selecAlltLocation(items: any): void {
    this.selectedLocation = items;
    this.fiterDataForLocation();

  }


  onDeSelectAllLocation() {
    this.selectedLocation = [];
    this.fiterDataForLocation();
  }





}
